import service from '@/services/superaccess'

const restore = {
  state: {
    restore_modal: false
  },
  mutations: {
    updateStatusRestoreModal (state, status) {
      state.restore_modal = status
    }
  },
  actions: {
    setStatusRestoreModal (context, payload) {
      context.commit('updateStatusRestoreModal', payload)
    },
    restore (context, payload) {
      return service.get('/api/configuration/restore', context)
    }
  }
}

export default restore



// WEBPACK FOOTER //
// app/javascript/src/store/restore.js